import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7499ac25"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-display-name" };
const _hoisted_2 = ["placeholder"];
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-pen" }, null, -1 /* HOISTED */));
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentDisplayNameInput',
    props: {
        displayName: {},
        placeholder: {}
    },
    emits: ["update:displayName"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const displayName = computed({
            get: () => props.displayName,
            set: (value) => emit("update:displayName", value),
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("input", {
                    placeholder: _ctx.placeholder,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((displayName).value = $event))
                }, null, 8 /* PROPS */, _hoisted_2), [
                    [_vModelText, displayName.value]
                ]),
                _hoisted_3
            ]));
        };
    }
});
